var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 159.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search-location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62,148.39A105.79,105.79,0,0,0,82.4,131a111.68,111.68,0,0,0,13.8-18.73l8.25,5.93a121.41,121.41,0,0,1-14.56,19.62A115.24,115.24,0,0,1,65,158.48a5.08,5.08,0,0,1-5.72.2,141.16,141.16,0,0,1-34.74-31C11.81,111.76,3.82,94.1,1.07,77.07-1.73,59.7.91,43,9.58,29.32A59.21,59.21,0,0,1,22.73,14.76C35,5,48.93-.12,62.85,0,76.3.11,89.58,5.11,101.06,15.58A56.21,56.21,0,0,1,111.24,28c8.62,14.23,11,32,8.05,50.29L110,71.66c1.44-14.15-.83-27.62-7.37-38.43a46.5,46.5,0,0,0-8.36-10.16c-9.55-8.71-20.48-12.87-31.47-13C51.2,10,39.44,14.4,29,22.69A48.64,48.64,0,0,0,18.15,34.76c-7.3,11.48-9.5,25.76-7.09,40.73,2.47,15.31,9.76,31.32,21.36,45.88a130.44,130.44,0,0,0,29.59,27Zm-10-119a37.91,37.91,0,0,1,45.1,49.1l25.75,18.36-8.44,12.8L89.37,91.63A37.9,37.9,0,1,1,52,29.43ZM76.6,40.55A29.83,29.83,0,1,0,90.24,58.87,29.76,29.76,0,0,0,76.6,40.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLocation);
export default __webpack_public_path__ + "static/media/search-location.981c69a96c50789964e5a2f2db846f6d.svg";
export { ForwardRef as ReactComponent };